import React from "react";

import { ButtonStandard, ModalBase } from "@performyard/py-components";

import { buildPromotionalUrl } from "./utils";

import aiPromotionImage from "./images/ai-promotion.png";

type AIPromotionModalProps = {
	isOpen: boolean;
	onClose: () => void;
	promotionId: string;
	userEmail: string;
};

export const AIPromotionModal = ({ isOpen, onClose, promotionId, userEmail }: AIPromotionModalProps) => {
	const learnMoreUrl = buildPromotionalUrl({
		email: userEmail,
		source: "modal",
		promotionId,
	});

	return (
		<ModalBase isOpen={isOpen} onClose={onClose} dangerouslySetClassName="w-[500px]">
			<div className="flex flex-col items-center gap-2 px-6 pt-2 pb-4">
				<img
					src={aiPromotionImage}
					alt="PerformYard AI features"
					className="h-[268px] w-[452px] rounded-2 object-cover"
				/>
				<h2 className="text-sub-heading font-semibold text-neutral-9">Unlock AI-Powered Insights</h2>
				<p className="text-center text-paragraph-3 text-neutral-9">
					PerformYard AI pulls themes from reviews, surveys and 1:1s, gives managers feedback tips, and
					recommends action based on the context of your unique performance data.
				</p>
			</div>
			<div className="flex justify-center px-6 pb-6">
				<div className="w-fit">
					<ButtonStandard color="primary" size="large" onClick={() => window.open(learnMoreUrl, "_blank")}>
						Learn More
					</ButtonStandard>
				</div>
			</div>
		</ModalBase>
	);
};
